<template>
  <main class="apple-tesla-cities">

    <!-- Hero / Header Căutare -->
    <section class="search-header text-center">
      <b-container>
        <b-row align-h="center" class="justify-content-center">
          <b-col lg="8" md="10">
            <span class="badge-subtle">Apreciat local &amp; Național</span>
            <h1 class="page-title">Descoperă orașele disponibile</h1>
            <p class="page-subtitle">Alege orașul tău pentru a vedea selecția de restaurante și preparate din zona ta.</p>

            <!-- Search Bar Modern -->
            <div class="search-wrapper">
              <div class="search-input-container">
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
                <b-input
                    type="text"
                    @keyup.enter="search"
                    v-model="searchTerm"
                    class="custom-search-input"
                    placeholder="Caută orașul tău..."
                ></b-input>
                <button @click="search" type="button" class="btn-search-action">
                  Căutare
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- Grid Orașe -->
    <section class="cities-section">
      <b-container>
        <b-row class="cities-wrapper justify-content-center">

          <b-col
              lg="4"
              md="6"
              sm="12"
              v-for="(city, index) in cities"
              :key="index"
              class="mb-4"
          >
            <router-link
                class="city-card"
                :to="{
                name: 'public.city.details',
                params: { slug: city.slug },
              }"
            >
              <div class="card-image-wrapper">
                <b-img
                    :src="'/cities/' + city.slug + '.jpg'"
                    :alt="city.name"
                    fluid
                    class="city-image"
                ></b-img>
                <div class="card-overlay"></div>
                <div class="card-info">
                  <h3 class="city-title">{{ city.name }}</h3>
                  <span class="explore-btn">
                    Explorează
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                  </span>
                </div>
              </div>
            </router-link>
          </b-col>

          <!-- Mesaj Fără Rezultate -->
          <b-col cols="12" v-if="!isBusy && cities.length === 0" class="text-center py-5">
            <p class="no-results-text">Nu am găsit niciun oraș cu acest nume.</p>
          </b-col>

        </b-row>

        <!-- Loader discret pentru Scroll Infinit -->
        <div v-if="isBusy" class="text-center py-4">
          <span class="loading-spinner"></span>
        </div>
      </b-container>
    </section>

  </main>
</template>

<script>
import PublicCities from "@/components/publicEndpoints/cities";

export default {
  name: "Cities",
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  data() {
    return {
      cities: [],
      paging: {
        page: 1,
        per_page: 12,
        total: 10,
        lastPage: 1000
      },
      filters: {},
      searchTerm: this.$route.params.searchTerm || "",
      lazyLoadingBusy: false,
      endOfResults: false,
      isBusy: false,
    };
  },
  methods: {
    search() {
      this.paging.page = 1;
      this.paging.search = this.searchTerm;
      this.endOfResults = false;
      this.getCities(true);
    },
    getCities(clearResults = false) {
      if (this.endOfResults || this.isBusy) {
        return;
      }
      this.isBusy = true;
      PublicCities.getAll(this.paging, this.filters).then((response) => {
        if (response.data.data.length === 0) {
          this.endOfResults = true;
        }
        if (clearResults) {
          this.cities = response.data.data;
        } else {
          response.data.data.forEach((city) => {
            if (!this.cityExists(city.id)) {
              this.cities.push(city);
            }
          });
        }
        this.paging.total = response.data.meta.total;
        this.paging.lastPage = response.data.meta.last_page;
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      }).catch(() => {
        this.isBusy = false;
        this.lazyLoadingBusy = false;
      });
    },
    handleScroll: function (e) {
      if (this.lazyLoadingBusy || this.endOfResults) {
        return;
      }
      const target = e.target.body || document.documentElement;
      const bodyHeight = target.offsetHeight;
      const innerHeight = window.innerHeight;
      const scrollY = window.scrollY;
      const citiesWrapper = document.querySelector('.cities-wrapper');

      if (!citiesWrapper) return;

      const beforeBottom = citiesWrapper.offsetTop;
      const overSize = 250;

      if (innerHeight + scrollY + overSize >= bodyHeight - beforeBottom) {
        this.lazyLoadingBusy = true;
        this.paging.page++;
        this.getCities();
      }
    },
    cityExists(id) {
      return this.cities.some((el) => {
        return el.id === id;
      });
    },
  },
  mounted() {
    this.getCities(true);
  },
};
</script>

<style scoped>
/* Container principal stil Apple Light */
.apple-tesla-cities {
  padding-top: 100px;
  padding-bottom: 80px;
  background-color: #f5f5f7;
  color: #1d1d1f;
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* Header & Search Section */
.search-header {
  margin-bottom: 48px;
}

.badge-subtle {
  display: inline-block;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1.5px;
  font-weight: 600;
  color: #86868b;
  margin-bottom: 12px;
}

.page-title {
  font-size: 2.75rem;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #1d1d1f;
  margin-bottom: 12px;
  line-height: 1.1;
}

.page-subtitle {
  font-size: 1.125rem;
  line-height: 1.47;
  color: #515154;
  max-width: 580px;
  margin: 0 auto 32px auto;
  font-weight: 400;
}

/* Search Bar Apple Modern - Aliniere perfectă */
.search-wrapper {
  max-width: 520px;
  margin: 0 auto;
}

.search-input-container {
  position: relative;
  display: flex;
  align-items: center; /* Aliniere verticală pe centru */
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 980px; /* Capsulă rotunjită */
  padding: 6px 6px 6px 18px; /* Padding ajustat direct pe container */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
}

.search-input-container:focus-within {
  border-color: #0071e3;
  box-shadow: 0 8px 24px rgba(0, 113, 227, 0.15);
}

.search-icon {
  color: #86868b;
  margin-right: 10px;
  flex-shrink: 0;
  display: block;
}

/* Resetăm complet input-ul Bootstrap pentru aliniere pe centru */
.custom-search-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  font-size: 0.95rem !important;
  color: #1d1d1f !important;
  height: 24px !important;
  line-height: 24px !important;
  display: flex !important;
  align-items: center !important;
}

.custom-search-input::placeholder {
  color: #86868b;
  line-height: normal;
}

.btn-search-action {
  background-color: #0071e3;
  color: #ffffff;
  border: none;
  border-radius: 980px;
  padding: 10px 22px;
  font-size: 0.88rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.btn-search-action:hover {
  background-color: #0077ed;
}

.btn-search-action:active {
  transform: scale(0.97);
}

/* City Cards Style */
.city-card {
  display: block;
  text-decoration: none !important;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  background: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: transform 0.35s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.35s ease;
}

.city-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.12);
}

.card-image-wrapper {
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  background-color: #e5e5ea;
}

.city-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.city-card:hover .city-image {
  transform: scale(1.05);
}

/* Dark Gradient Overlay pe imagine */
.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.65) 100%);
  transition: opacity 0.3s ease;
}

.card-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.city-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.01em;
  color: #ffffff;
}

.explore-btn {
  font-size: 0.82rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.city-card:hover .explore-btn {
  color: #ffffff;
  transform: translateX(3px);
}

.no-results-text {
  font-size: 1.1rem;
  color: #86868b;
}

/* Loader Minimalist */
.loading-spinner {
  display: inline-block;
  width: 28px;
  height: 28px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #0071e3;
  animation: spin 0.8s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
